import { useState } from 'react';
import type { EntityKind, FeedItem } from '@/api/base-types';
import { entityPath, useBaseMutation, useFeed } from '@/api/base';
import { api } from '@/api/client';
import { Button } from '@/components/kit/Button';
import { Feed } from '@/components/kit/Feed';
import { Skeleton } from '@/components/kit/Note';
import { Panel } from '@/components/kit/Panel';
import { useToast } from '@/components/kit/Toast';
import { errorText } from './useUndoable';

/**
 * Лента карточки (ТЗ M2 3.1, feedPanel в макете): комментарий сверху,
 * ниже комментарии и системные события по дням. Звонки и задачи
 * будущих модулей лягут сюда же.
 */
export function FeedPanel({ entity, id, placeholder }: { entity: EntityKind; id: string; placeholder: string }) {
  const toast = useToast();
  const feed = useFeed(entity, id);
  const [text, setText] = useState('');
  const add = useBaseMutation((t: string) => api.post<FeedItem>(`${entityPath(entity, id)}/comments`, { text: t }));

  const items = feed.data?.pages.flatMap((p) => p.items) ?? [];

  return (
    <Panel title="Лента">
      <div className="cmp">
        <label className="field">
          <span className="lbl">Комментарий</span>
          <textarea value={text} placeholder={placeholder} onChange={(e) => setText(e.target.value)} />
        </label>
        <Button
          small
          disabled={!text.trim() || add.isPending}
          onClick={() =>
            add.mutate(text, {
              onSuccess: () => {
                setText('');
                toast.show('Комментарий добавлен');
              },
              onError: (e) => toast.showError(errorText(e)),
            })
          }
        >
          Добавить комментарий
        </Button>
      </div>
      <hr className="hair" />
      {feed.isLoading ? (
        <div className="fpad">
          <Skeleton width="40%" />
        </div>
      ) : feed.isError ? (
        <div className="fpad ph-empty">Ленту не удалось загрузить.</div>
      ) : (
        <Feed items={items} />
      )}
      {feed.hasNextPage ? (
        <Button small tone="ghost" onClick={() => void feed.fetchNextPage()} disabled={feed.isFetchingNextPage}>
          Показать ещё
        </Button>
      ) : null}
    </Panel>
  );
}
